export default "__VITE_ASSET__794b32f7__"